enum ProductInformationExpandedAccordionEnum {
	goodToKnow = 'goodToKnow',
	materialsAndCare = 'materialsAndCare',
	safetyAndCompliance = 'safetyAndCompliance',
	sustainabilityAndEnvironment = 'sustainabilityAndEnvironment'
}
export default ProductInformationExpandedAccordionEnum;
